/**
 * Safe localStorage/sessionStorage utilities
 * These handle cases where storage is unavailable (private browsing, security settings, etc.)
 */

export const safeGetItem = (key: string, storage: Storage = localStorage): string | null => {
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
};

export const safeSetItem = (key: string, value: string, storage: Storage = localStorage): void => {
  try {
    storage.setItem(key, value);
  } catch {
    // Storage not available (private browsing, security settings, etc.)
  }
};

export const safeRemoveItem = (key: string, storage: Storage = localStorage): void => {
  try {
    storage.removeItem(key);
  } catch {
    // Storage not available
  }
};

// Session storage specific helpers
export const safeSessionGetItem = (key: string): string | null => {
  return safeGetItem(key, sessionStorage);
};

export const safeSessionSetItem = (key: string, value: string): void => {
  safeSetItem(key, value, sessionStorage);
};

export const safeSessionRemoveItem = (key: string): void => {
  safeRemoveItem(key, sessionStorage);
};
